<template>
	<v-flex :class="classes">
		<v-text-field
			:value="nValue"
			:color="color"
			:label="label"
			:placeholder="placeholder"
			:rules="rules"
			:required="required"
			:box="box"
			:outline="outline"
			:hint="hint"
			:persistent-hint="persistentHint"
			:readonly="readonly && $route.params.id != 'new'"
			:disabled="disabled && $route.params.id != 'new'"
			@change="handleChange"
		/>		
	</v-flex>
</template>

<script>
import { propsMixin } from '@/mixins/FieldsProps'

export default {
	mixins: [propsMixin],
	data() {
		return {
			nValue: ''
		}
	},
	created() {
		if (this.value) this.nValue = this.value
	},
	methods: {
		handleChange(valor) {
			// console.log(valor)
			if (this.sensitive) {
				valor = this.sensitive(valor)
			}
			this.nValue = valor
			this.$emit('input', valor)
		}
	}
}
</script>

